import React, {useEffect, useState} from 'react'
import {useGetOptionsSelect} from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import {usePropsSelect} from "../../../../hooks/useProps/usePropsSelect";
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import {
    getDataToCreateOrEditFaltaAPI, getEmpleadosToCreateFaltaAPI,
    getTiposFaltaAPI,
} from "../../../../consumers/backendApisUrls";
import {
    calculateDaysInBetween,
    initialAllOptionPromises, isNullOrUndefinded,
} from "../../../../helper/utils";
import {EXTENSION_PDF, TIPO_FALTA} from "../../../../constants/hardCodedConstants";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import {AlertErrorMaxFileSizeMessageGeneric} from "../../../../components/alerts/AlertErrorMaxFileSizeMessage";
import InputText from "../../../../components/modalComponents/InputText";
import {Div} from "../../../registroMaternidad/modales/components/Components";
import InputDate from "../../../../components/modalComponents/InputDate";
import InputTextArea from "../../../../components/modalComponents/InputTextArea";
import InputSelect from "../../../../components/modalComponents/InputSelect";
import ConfirmarGuardar from "./ConfirmarGuardar";
import {toast} from "react-toastify";
import InputSearchAsync from "../../../../components/modalComponents/InputSearchAsync";

const KEYS_DROPDOWN = ["IdTipoFalta"];

const Falta = ({
                   SECTION_NAME,
                   idEmpleado,
                   formValuesFaltas,
                   setFormValuesFaltas,
                   KEYS,
                   fromAdminPage,
                   isCreate,
                   isEditable,
                   handleSubmitRegistrar,
                   mensajeConfirmarRegistrar,
                   showModalConfirmarRegistrar,
                   toggleConfirmarGuardar,
                   IdFalta
               }) => {
    const [allDropdowns, setAllDropdowns] = useState([]);
    const [getOption] = useGetOptionsSelect();

    const [selectProps] = usePropsSelect(allDropdowns, formValuesFaltas, setFormValuesFaltas, SECTION_NAME);
    const [commonProps] = usePropsInputs(formValuesFaltas, setFormValuesFaltas, SECTION_NAME);

    const [executeManagePost] = useManagePostRequest();
    const [executeMangGet] = useManageGetRequest();

    const [isUploadingSutento, setIsUploadingSustento] = useState(false);
    const [modalData, setModalData] = useState({});

    const getDropdowns = async () => {
        //setIsLoading(true);
        const dropdownsPromises = () => [
            getOption(getTiposFaltaAPI()),
        ];
        await initialAllOptionPromises(
            dropdownsPromises,
            KEYS_DROPDOWN,
            handleDropdowns
        );
        //setIsLoading(false);
    };

    const getOptions = async () => {

    }

    const getDataForModal = async () => {
        let idFalta = isCreate === true ? 0 : IdFalta;
        const api = getDataToCreateOrEditFaltaAPI(idFalta);
        await executeMangGet(api, ({ data }) => getDataForModalCallBack(data), false);
    }

    const getDataForModalCallBack = async (data) => {
        setModalData(data)
        if (!isNullOrUndefinded(data?.Message)){
            toast.error(data?.Message);
        }
    };

    const handleDropdowns = (data) => {
        setAllDropdowns(data);
    };

    const init = async () => {

        getDropdowns();
        getInitData();
    };

    const getInitData = async () => {
        getDataForModal();
    }

    function getDays() {
        if (formValuesFaltas[KEYS.FechaInicio] && formValuesFaltas[KEYS.FechaFin])
            return calculateDaysInBetween(formValuesFaltas[KEYS.FechaInicio], formValuesFaltas[KEYS.FechaFin]);

        return "-";
    }

    useEffect(() => {
        init();
        getOptions();
    }, []);


    return (
        <>
            {showModalConfirmarRegistrar &&
                <div className="modal-contactanos modal-response-ficha-background">
                    <ConfirmarGuardar toggleModal={toggleConfirmarGuardar} submit={handleSubmitRegistrar}>
                        {formValuesFaltas?.IdTipoFalta === TIPO_FALTA.NoJustificada.Id &&
                            <p>
                                Se guardará una nueva falta y descuento correspondiente en la planilla de <strong>{mensajeConfirmarRegistrar}</strong>
                            </p>
                        }
                        {formValuesFaltas?.IdTipoFalta === TIPO_FALTA.Justificada.Id &&
                            <p>
                                Se guardará una nueva falta correspondiente a la planilla de <strong>{mensajeConfirmarRegistrar}</strong> y no pasará a descuento en planilla.
                            </p>
                        }

                    </ConfirmarGuardar>
                </div>
            }
            {isCreate === false &&
                <Div col={8}>
                    <InputText
                        label={"Empleado"}
                        name={"Empleado"}
                        value={formValuesFaltas[KEYS.NombreEmpleado]}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled
                    />
                </Div>
            }

            <Div col={4}>
                <InputSelect
                    label="Tipo de Falta"
                    isRequired={true}
                    direction="column"
                    isDisabled={!isEditable}
                    {...selectProps(KEYS.IdTipoFalta, [
                        KEYS.SustentoFalta,
                        KEYS.Justificacion,
                    ])}
                />
            </Div>

            <Div col={4}>
                <InputDate
                    label={"Fecha de inicio"}
                    name={KEYS.FechaInicio}
                    min={modalData?.MinDate}
                    max={formValuesFaltas[KEYS.FechaFin] == null ? modalData?.MaxDate : formValuesFaltas[KEYS.FechaFin]}
                    {...commonProps(KEYS.FechaInicio)}
                    sectionName={SECTION_NAME}
                    isDisabled={!isEditable}
                    isRequired={true}
                    direction="column"
                />
            </Div>
            <Div col={4}>
                <InputDate
                    label={"Fecha de fin"}
                    name={KEYS.FechaFin}
                    min={formValuesFaltas[KEYS.FechaInicio] == null ? modalData?.MinDate : formValuesFaltas[KEYS.FechaInicio] }
                    max={modalData?.MaxDate}
                    {...commonProps(KEYS.FechaFin)}
                    sectionName={SECTION_NAME}
                    isDisabled={!isEditable}
                    isRequired={true}
                    direction="column"

                />
            </Div>

            <Div col={4}>
                <InputText
                    label={"Días"}
                    name={"Días"}
                    value={getDays()}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isDisabled
                />
            </Div>
            {formValuesFaltas?.IdTipoFalta === TIPO_FALTA.Justificada.Id &&
                <Div col={8}>
                    <InputTextArea
                        label="Justificación"
                        {...commonProps(KEYS.Justificacion)}
                        isDisabled={!isEditable}
                        isRequired={true}
                        placeholder={" "}
                        direction="column"
                    />
                </Div>
            }

            {formValuesFaltas?.IdTipoFalta === TIPO_FALTA.NoJustificada.Id &&
                <Div col={8}>
                    <InputTextArea
                        label="Comentario"
                        {...commonProps(KEYS.Comentario)}
                        isDisabled={!isEditable}
                        isRequired={false}
                        placeholder={" "}
                        direction="column"
                    />
                </Div>
            }

            {!isNullOrUndefinded(formValuesFaltas?.IdTipoFalta) &&
                <>
                    <Div col={4} additionalClass="d-flex justify-content-center align-items-center mb-1">
                        <a className="btn generic-button-buscador"  target="_blank" href={modalData[KEYS.LinkProcedimiento] ?? ""}>
                            Mira aquí el procedimiento
                        </a>
                    </Div>
                </>
            }

            {!isNullOrUndefinded(formValuesFaltas[KEYS.MotivoRechazo]) && formValuesFaltas[KEYS.MotivoRechazo] !== "" &&
                <Div col={12}>
                    <InputTextArea
                        label={"Motivo Rechazo"}
                        direction="column"
                        {...commonProps(KEYS.MotivoRechazo)}
                        placeholder={" "}
                        isDisabled={true}
                        isRequired={false}
                    />
                </Div>
            }

            {!isNullOrUndefinded(formValuesFaltas[KEYS.MotivoObservacion]) && formValuesFaltas[KEYS.MotivoObservacion] !== "" &&
                <Div col={12}>
                    <InputTextArea
                        label={"Observación"}
                        direction="column"
                        {...commonProps(KEYS.MotivoObservacion)}
                        placeholder={"  "}
                        isDisabled={true}
                        isRequired={false}
                    />
                </Div>
            }

            {!isNullOrUndefinded(formValuesFaltas[KEYS.MotivoAnulacion]) && formValuesFaltas[KEYS.MotivoAnulacion] !== "" &&
                <Div col={12}>
                    <InputTextArea
                        label={"Motivo Anulación"}
                        direction="column"
                        {...commonProps(KEYS.MotivoAnulacion)}
                        placeholder={"  "}
                        isDisabled={true}
                        isRequired={false}
                    />
                </Div>
            }

            {formValuesFaltas?.IdTipoFalta === TIPO_FALTA.Justificada.Id &&
                <Div>
                    <InputUploadFile
                        toolTipText="Adjuntar un solo documento en formato pdf, si posees más de un sustento, debes escanear todo como un solo archivo (no mayor de 2MB)"
                        label="Sustento"
                        name={KEYS.SustentoFalta}
                        uploadFile={formValuesFaltas[KEYS.SustentoFalta]}
                        setUploadFile={(res) =>
                            setFormValuesFaltas({...formValuesFaltas, [KEYS.SustentoFalta]: res})
                        }
                        sectionName={SECTION_NAME}
                        setIsUploading={setIsUploadingSustento}
                        validExtensions={EXTENSION_PDF}
                        isDisabled={!isEditable || isUploadingSutento}
                        direction="column"
                        NoFileMessage={isUploadingSutento ? "Subiendo archivo..." : "No se ha subido archivo"}
                        maxFileSize={2097152} //2MB
                        ToastArchivoNoValido={() => AlertErrorMaxFileSizeMessageGeneric('pdf', '2MB')}
                        isRequired
                    />
                </Div>
            }




            <Div col={12}>
                {formValuesFaltas?.IdTipoFalta === TIPO_FALTA.Justificada.Id &&
                    <div className='form-check-label  mt-1 red-below-modal-message'
                         style={{fontSize: "14px", fontWeight: "600"}}>
                        Las faltas justificadas no serán descontadas de planilla y es necesario adjuntar documentos que la sustenten.
                    </div>
                }

                {formValuesFaltas?.IdTipoFalta === TIPO_FALTA.NoJustificada.Id &&
                    <div className='form-check-label  mt-1 red-below-modal-message'
                         style={{fontSize: "14px", fontWeight: "600"}}>
                        Las faltas injustificadas serán descontadas de planilla
                    </div>
                }
            </Div>


        </>
    )
}

export default Falta;